import { registerQuery } from 'data-fetching-client'; // @ts-expect-error untyped dependency

import { getModuleDetails } from '../../clients/ecosystemClient';

function getModuleDetailsData({
  slug
}) {
  return getModuleDetails(slug);
}

export const GET_MODULE_DETAILS = registerQuery({
  fieldName: 'details',
  args: ['slug'],
  fetcher: getModuleDetailsData
});